module.exports = __webpack_public_path__ + "static/media/instructor_code.40a27cb6.jpg";